export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';
export const VARIANT_A = 'a';
export const VARIANT_B = 'b';
export const VARIANT_MYACCOUNT = 'MyAccount';
export const VARIANT_LOGINSIGNUP = 'LoginSignup';

export function isVariantAorB(variant) {
    return variant === VARIANT_A || variant === VARIANT_B;
}

// Variants for Pina_Home_PatientHomeAsHomepage
export const VARIANT_ON_DONOTREDIRECT = 'donotredirect';
export const VARIANT_ON_REDIRECT = 'redirect';

/* Optimizely experiments */

// This experiment is used exclusively by nginx to determine whether to send the client to monolith or 1Z.
// We use it as a feature flag here in PWA to log to datadog when the client received the monolith variant but somehow
// ended up here in PWA.
export const ONE_Z_SEARCH = {
    experimentId: '1ZSearchRouter',
    defaultAssignment: 'default',
    isFeatureFlag: false,
};

export const ONE_Z_PRACTICE = {
    experimentId: '1ZPracticeTest1',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
};

// This experiment is used exclusively by PWA to record profile conversion.
// Nginx and monolith shouldn't touch this experiment at all.
export const ONE_Z_SEARCH_PWA = {
    experimentId: '1ZSearchTest-PWA',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
};

export const HOMEPAGE_HEADER_V2 = {
    experimentId: 'HomepageHeaderV2',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const SHOW_FACETED_SEARCHBAR = {
    experimentId: 'FacetedSearchBar',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const SHOW_REVIEW_COUNT = {
    experimentId: 'FlapjackReviewCount',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER = {
    experimentId: 'Pina_InsurancePicker_PersistChosenCarrier',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
};

export const PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON = {
    experimentId: 'Pina_InsurancePicker_UseDropdownHeaderChevron',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
};

export const EVENT_LOOP_TEST = {
    experimentId: 'EventLoopTest',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const TELEHEALTH_LINK_TO_PROFILE = {
    experimentId: 'TelPWA_LinkToProfile',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const FULL_STORY = {
    experimentId: 'FullStory',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PINA_HAMBURGER_MENU_WELL_GUIDE_LINK = {
    experimentId: 'Pina_HamburgerMenu_WellGuideLink',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const TELEHEALTH_LINK_TO_BOOKING = {
    experimentId: 'TelPWA_LinkToBooking',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const SPO_USE_SPOOM = {
    experimentId: 'Spo_UseSPOOM',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
};

export const SHOW_FIND_SIMILAR_DOCTORS = {
    experimentId: 'PatientCore_FindSimilarDoctors',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINA_PROVIDER_AVAILABILITY_TOOLTIP = {
    experimentId: 'Pina_Provider_Availability_Tooltip',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINA_PROFILE_CHECK_INSURANCE_MODAL = {
    experimentId: 'Pina_Profile_CheckInsuranceModal',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const PINA_SEARCH_ADD_INSURANCE_BANNER = {
    experimentId: 'Pina_Search_AddInsuranceBanner',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
};

export const PINA_HOME_PATIENT_HOME_AS_HOMEPAGE = {
    experimentId: 'Pina_Home_PatientHomeAsHomepage',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PCE_TIME_SLOTS_ALWAYS_YELLOW = {
    experimentId: 'PCE_TimeSlotsAlwaysYellow',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

// This is a fake experiment tesing the results of setting assignments based on trackingId instead of sessionId
export const PCE_TRACKING_ID_DUMMY = {
    experimentId: 'PCE_TrackingIdDummy',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PCE_SEARCH_ON_PREVIEW_CHURNED = {
    experimentId: 'PCE_SearchOnPreviewChurned',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const FLAT_PROFILE = {
    experimentId: 'FlatProfile',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
    visitorIdType: 'trackingId',
};

export const PINA_DOCTOR_PROFILE_OUT_OF_NETWORK_MODAL = {
    experimentId: 'Pina_Pwa_Doctor_Profile_Out_Of_Network',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
};

export const PINA_HOME_JANUARY_WELLNESS = {
    experimentId: 'Pina_Home_JanuaryWellness',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PCE_SUBWAY_HOMEPAGE = {
    experimentId: 'PCE_SubwayHomepage',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};
export const PINA_PWA_MOBILE_WEB_UPCOMING_APPOINTMENTS_MENU = {
    experimentId: 'Pina_Pwa_MobileWeb_UpcomingAppointmentsMenu',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};
